import React, { cloneElement } from 'react'
import { Button, Col, Row, Form, Table, Label, Input, Modal, ModalBody, ModalFooter, ModalHeader, FormGroup, Spinner, ButtonGroup } from 'reactstrap'
import axios from 'axios'
import StorageService from '../services/StorageService'
import { MdDone, MdClear, MdCreate, MdSearch, MdWarning } from 'react-icons/md'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import PosProductModal from '../components/PosProductModal'
import PosIgnoreStockForm from '../components/PosIgnoreStockForm'
import PosNettPriceForm from '../components/PosNettPriceForm'
import SearchInput from '../components/SearchInput'
import { MDBDataTableV5, MDBDataTable } from 'mdbreact'
import '@fortawesome/fontawesome-free/css/all.min.css'
import { getProductCategory_v2 } from '../utils/dropdownlist'
import { CSVLink } from 'react-csv'
//import cloneDeep from 'lodash/cloneDeep';
import detail_img from '../assets/img/details.png'
import empty_img from '../assets/img/empty.png'
import Featured from '../assets/img/featured.png'
import Recommend from '../assets/img/recommended.png'
import New from '../assets/img/new.png'
import OnSale from '../assets/img/sales.png'
import inventory_img from '../assets/img/inventory.png'
import link_img from '../assets/img/link.png'

const headers = [
  {
    label: 'Product No.',
    key: 'product_no',
  },
  {
    label: 'Name',
    key: 'name',
  },
  {
    label: 'Category',
    key: 'category',
  },
  {
    label: 'Type',
    key: 'product_type',
  },
  {
    label: 'Price',
    key: 'price',
  },
  {
    label: 'Quantity',
    key: 'qty',
  },
  {
    label: 'Ignore Stock',
    key: 'Ignore_Stock',
  },
  {
    label: 'Badge',
    key: 'badge',
  },
]

const tbcolumn = [
  {
    label: <input type="checkbox" />,
    field: 'checkbox',
    sort: 'disabled',
    width: 50,
  },
  {
    label: 'Product No.',
    field: 'product_no',
    sort: 'asc',
  },
  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
  },
  {
    label: 'Category',
    field: 'category',
    sort: 'asc',
  },
  {
    label: 'Type',
    field: 'product_type',
    sort: 'asc',
  },
  {
    label: 'Price',
    field: 'price',
    sort: 'asc',
  },
  {
    label: 'Quantity',
    field: 'qty',
    sort: 'asc',
  },
  {
    label: 'Show In Menu',
    field: 'Default_List',
    sort: 'asc',
  },
  {
    label: 'Ignore Stock',
    field: 'Ignore_Stock',
    sort: 'asc',
  },
  // {
  //   label: 'FB Link',
  //   field: 'FB_Link',
  //   sort: 'asc',
  // },
  {
    label: 'Badge',
    field: 'Badge',
    sort: 'asc',
  },
  {
    label: 'Nett Price',
    field: 'Nett_Price',
    sort: 'asc',
  },
  // {
  //   label: 'Description',
  //   field: 'eng_description',
  //   sort: 'asc',
  // },
  {
    label: 'Action',
    field: 'Action',
    sort: 'asc',
  },
]

class PosStoreProductTable extends React.Component {
  _isMounted = true
  sortKey = sessionStorage.getItem('sortKey')
  comp = StorageService.getSession('selected_org')
  constructor(props) {
    super(props)
    this.state = {
      role: '',
      isLoading: true,
      modal: false,
      formModal: false,
      confirmModal: false,
      importModal: false,
      stockModal: false,
      ignorestoreModal: false,
      nettpriceModal: false,
      ifFiltered: false,
      sortKey: this.sortKey ? this.sortKey : '',
      isGlobal: '',
      isEdit: false,
      isStock: false,
      productList: [],
      filteredList: [],
      categoryList: [],
      redirect: false,
      selectedId: '',
      selectedData: '',
      searchKey: '',
      marketplace: 0,
      actionList: [{ name: 'Adjust' }, { name: 'Add Stock' }, { name: 'Deduct Stock' }],
      stockAction: 'Adjust',
      qty_data: null,
      amount: null,
      ignore_stock: null,
      New: New,
      Recommend: Recommend,
      Featured: Featured,
      OnSale: OnSale,
      bulkDelete: false,
      checkedRows: [],
    }
  }

  componentDidMount() {
    const user = StorageService.getSession('user_info')
    //if (user.superUser) {
    this.getProductCategory()
    this.getProductList()
    // } else {
    //   this.setState({
    //     redirect: true,
    //   });
    // }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data.role !== state.role) {
      return {
        role: props.data.role,
        store_type: props.data.store_type,
        marketplace: props.data.marketplace,
      }
    }
    return null
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  getProductCategory() {
    getProductCategory_v2()
      .then(result => {
        if (this._isMounted) {
          if (result.error == true && result.message != 'Success') {
            alert(result.message)
            return
          }
          this.setState({
            categoryList: result.data.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  handleCheck = (e, isall) => {
    let checkedRows = []
    if (isall) {
      if (e.target.checked) {
        for (let i of this.state.filteredList) {
          checkedRows.push(i.id)
        }
      } else checkedRows = []
    } else {
      checkedRows = [...this.state.checkedRows]
      if (e.target.checked) checkedRows.push(e.target.name)
      else checkedRows.splice(checkedRows.indexOf(e.target.name), 1)
    }
    this.setState(
      {
        checkedRows,
        bulkDelete: isall ? (e.target.checked ? true : false) : false,
      },
      () => this.custData('check', this.state.filteredList, false),
    )
  }

  handleCheckHeader = (e, isall) => {
    let checkedRows = []

    if (e.target.checked) {
      for (let i of this.state.filteredList) {
        checkedRows.push(i.id)
      }
    } else checkedRows = []

    this.setState(
      {
        checkedRows,
        bulkDelete: e.target.checked,
      },
      () => this.custData('check', this.state.filteredList),
    )
  }

  handleCheckItem = e => {
    let { name } = e.target
    let id = parseInt(name)
    let checkedRows = []
    checkedRows = [...this.state.checkedRows]
    if (e.target.checked) checkedRows.push(id)
    else checkedRows.splice(checkedRows.indexOf(id), 1)
    this.setState(
      {
        checkedRows,
        //bulkDelete: isall ? (e.target.checked ? true : false) : false,
      },
      () => this.custData('check', this.state.filteredList),
    )
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit: id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    })
  }

  toggleForm = (action, id) => () => {
    return this.setState({
      formModal: !this.state.formModal,
      isEdit: action == 'EDIT' ? true : false,
      isStock: action == 'STOCK' ? true : false,
      selectedId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    })
  }

  toggleConfirmModal = (name, id) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: name,
      selectedId: id,
    })
  }

  toggleImportModal = () => () => {
    return this.setState({
      importModal: !this.state.importModal,
    })
  }

  stockModal =
    (id = null, ignore_stock = null, qty_data = null) =>
    () => {
      return this.setState({
        stockModal: !this.state.stockModal,
        selectedId: id,
        ignore_stock: ignore_stock,
        qty_data: qty_data == null ? null : JSON.parse(qty_data),
        amount: qty_data == null ? 0 : JSON.parse(qty_data)[0].qty,
      })
    }

  toggleIgnoreStockModal = () => () => {
    return this.setState({
      ignorestockModal: !this.state.ignorestockModal,
    })
  }

  toggleNettPriceModal = () => () => {
    return this.setState({
      nettpriceModal: !this.state.nettpriceModal,
    })
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      modal: false,
      formModal: false,
      stockModal: false,
      ignorestockModal: false,
      nettpriceModal: false,
      checkedRows: [],
    })

    if (reload) {
      window.location.reload()
    } else {
      this.getProductList()
    }
  }

  changeHandler = event => {
    const { name, value } = event.target

    this.setState({
      [name]: value,
    })

    if (name === 'sortKey') {
      sessionStorage.setItem('sortKey', value)
    }
  }

  // checkHandler = e => {
  //   let { name, value } = e.target;
  //   this.setState({
  //     selectedData: !this.state.selectedData,
  //   });
  // };

  checkHandler = e => {
    let { name } = e.target
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      product_id: this.state.selectedId,
      ignorestock: !this.state[name] ? '1' : '0',
      update_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/inventory/ignorestock', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Product updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({
          ignore_stock: !this.state[name],
        })
        this.getProductList()
      })
      .catch(error => {
        console.error(error)
        alert(error)
        if (error === 'Unauthorised') {
          this.setState({ redirect: true })
        }
      })
  }

  // ignoreStock = e => {
  //   const user = StorageService.getSession('user_info');
  //   const url = process.env.REACT_APP_UNITY_API2_URL;

  //   const data = {
  //     session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
  //     store_id: this.props.match.params.id,
  //     product_id: this.state.selectedId,
  //     ignorestock: this.state.selectedData ? '1' : '0',
  //     update_by: user.email,
  //   };

  //   axios
  //     .post(url + ':3002/v1/product/store/inventory/ignorestock', data)
  //     .then(response => {
  //       const result = response.data;
  //       if (result.error == true) {
  //         this.notificationSystem.addNotification({
  //           title: <MdClear />,
  //           message: result.message,
  //           level: 'error',
  //           position: 'br',
  //           autoDismiss: 4,
  //           dismissible: 'click',
  //         });
  //         return;
  //       }

  //       this.notificationSystem.addNotification({
  //         title: <MdDone />,
  //         message: 'Product updated successfully.',
  //         level: 'success',
  //         position: 'br',
  //         autoDismiss: 4,
  //         dismissible: 'click',
  //       });
  //       this.setState({
  //         selectedId: '',
  //         selectedData: '',
  //         stockModal: false,
  //       });
  //       this.getProductList();
  //     })
  //     .catch(error => {
  //       alert(error);
  //       if (error === 'Unauthorised') {
  //         this.setState({ redirect: true });
  //       }
  //     });
  // };

  // sortData() {
  //   const { productList, sortKey } = this.state;
  //   if (sortKey.length) {
  //     productList.sort((a, b) => a[sortKey] - b[sortKey]).reverse();

  //     this.setState({ productList });
  //   } else {
  //     this.getProductList();
  //   }
  // }

  // searchChange = event => {
  //   const searchKey = event.target.value.toLowerCase();
  //   this.setState({ searchKey }, () => this.filteredList());
  // };

  // filteredList = () => {
  //   let products = this.state.productList;
  //   let searchKey = this.state.searchKey;

  //   products = products.filter(product => {
  //     return (
  //       product.product_no.toLowerCase().indexOf(searchKey) != -1 ||
  //       product.name.toLowerCase().indexOf(searchKey) != -1
  //     );
  //   });
  //   this.setState({ filteredList: products });
  // };

  adjustStock() {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL
    let fullUrl
    let qtyData = [...this.state.qty_data]
    //const qtyData = cloneDeep(this.state.qty_data);
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      product_id: this.state.selectedId,
      store_id: this.state.store_id,
    }
    if (this.state.stockAction === 'Adjust') {
      qtyData[0].qty = this.state.amount
      fullUrl = url + ':3002/v1/product/store/inventory/adjust'
      data.qty_data = JSON.stringify(qtyData)
      data.adjust_by = user.email
    } else {
      qtyData[0].qty = this.state.stockAction === 'Add Stock' ? this.state.amount : '-' + this.state.amount
      fullUrl = url + ':3002/v1/product/store/inventory/add'
      data.qty_data = JSON.stringify(qtyData)
      data.updated_by = user.email
    }

    axios
      .post(fullUrl, data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.closeModal(<MdDone />, 'Stock updated successfully.', 'success', false)
      })
      .catch(error => {
        if (error.response) {
          alert(error.response.data.message)
        }
        // else if (error.request) {
        //   console.log(error.request);
        // }
        else {
          alert('Error', error.message)
        }
      })
  }

  filterData() {
    const { productList, sortKey } = this.state

    if (sortKey.length) {
      let item = productList.filter(x => x.category === sortKey)
      this.setState({ filteredList: item }, () => this.custData('filter', item))
    } else {
      this.setState({ filteredList: productList }, () => this.custData('filter', productList))
    }

    this.setState({
      bulkDelete: false,
      checkedRows: [],
    })
  }

  delete = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    let data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      product_id_list: this.state.checkedRows,
      store_id: this.props.data.store_id,
      remove_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/remove/batch', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: `Product deleted successfully.`,
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false })
        this.getProductList()
      })
      .catch(error => {
        alert(error)
      })
  }

  import = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const comp = StorageService.getSession('selected_org')
    let data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.props.data.store_id,
      added_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/add/all', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: `Product imported successfully.`,
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ importModal: false })
        this.getProductList()
      })
      .catch(error => {
        alert(error)
      })
  }

  getProductList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }
    let fullUrl,
      store_id = ''
    if (!this.props.isGlobal) {
      store_id = this.props.data.store_id
      data.store_id = store_id
      fullUrl = url + ':3002/v1/product/store'
    } else {
      fullUrl = url + ':3002/v1/product'
    }

    axios
      .post(fullUrl, data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        return result.data
      })
      .then(data => {
        this.custData('api', data)
      })
      .catch(error => {
        alert(error)
      })
  }

  custData(method, data) {
    tbcolumn[0].label = (
      <Input
        type="checkbox"
        checked={this.state.bulkDelete}
        onChange={e => {
          this.handleCheckHeader(e, true)
        }}
      />
    )
    for (let i of data) {
      if (i.qty_data) {
        i.qty = JSON.parse(i.qty_data)[0].qty
      }
      if (i.price_data) {
        i.price = JSON.parse(i.price_data)[0].price
      }

      i.Default_List = <span className={'ps-indicator ' + (i.default_list == '1' ? 'on' : 'off')}>{i.default_list == '1' ? 'Yes' : 'No'}</span>

      i.Ignore_Stock = <span className={'ps-indicator ' + (i.ignore_stock == '1' ? 'on' : 'off')}>{i.ignore_stock == '1' ? 'Yes' : 'No'}</span>

      let link = `https://fb.unitysuite.app/${this.comp.CompanyCode}/${this.props.data.store_code}/p/${i.id}?store=${this.props.match.params.id}`

      i.Nett_Price = <span className={'ps-indicator ' + (i.nett_price == '1' ? 'on' : 'off')}>{i.nett_price == '1' ? 'Yes' : 'No'}</span>

      i.Badge = i.show_badge ? <img src={this.state[i.badge.replace(/\s/g, '')]} className="badge_img" /> : <img src={empty_img} className="badge_img" />

      i.checkbox = (
        <Input
          type="checkbox"
          name={i.id}
          checked={this.state.checkedRows.some(j => j == i.id)}
          onChange={e => {
            this.handleCheckItem(e, false)
          }}
        />
      )

      i.Action = (
        <div className="ps-button-group">
          {(this.state.store_type == 'Main' || this.state.marketplace == 1) && this.state.role == 'Admin' && (
            <div className="ps-action-button">
              {/* <Button
                  className="theme-button theme-button-secondary"
                  onClick={() => this.detail(i.id)}
                >
                  View
                </Button>
                <Button
                  className="theme-button theme-button-primary-light"
                  onClick={this.stockModal(i.id, i.ignore_stock)}
                >
                  Stock
                </Button> */}
              <img src={detail_img} className="detail_img" onClick={() => this.detail(i.id)} />
              <img src={inventory_img} className="icon_img" onClick={this.stockModal(i.id, i.ignore_stock, i.qty_data)} />
              <img src={link_img} className="icon_img" onClick={() => this.copyClipBoard(link)} />
            </div>
          )}
        </div>
      )
    }

    if (this._isMounted) {
      let item = data
      if (this.state.sortKey) {
        item = data.filter(x => x.category === this.state.sortKey)
      }
      this.setState({
        productList: method == 'api' ? data : this.state.productList,
        filteredList: item,
        store_id: this.props.data.store_id,
        isGlobal: this.props.isGlobal,
        isLoading: false,
      })
    }
  }

  detail = id => {
    this.props.history.push({
      pathname: `/posstore/${this.props.data.store_id}/product/` + id,
    })
  }

  copyClipBoard = link => {
    navigator.clipboard.writeText(link)
    this.notificationSystem.addNotification({
      title: <MdDone />,
      message: 'Link copied to clipboard',
      level: 'info',
      position: 'br',
      autoDismiss: 4,
      dismissible: 'click',
    })
  }

  CsvNotFound() {
    this.notificationSystem.addNotification({
      title: <MdWarning />,
      message: 'Data Not Found',
      level: 'warning',
      position: 'br',
      autoDismiss: 4,
      dismissible: 'click',
    })
  }

  PriceModification = () => {
    this.props.history.push({
      pathname: `/posstore/${this.props.data.store_id}/pricemodification`,
    })
  }

  ProductCondition = () => {
    this.props.history.push({
      pathname: `/posstore/${this.props.data.store_id}/productcondition`,
    })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }
    const data = {
      columns: tbcolumn,
      rows: this.state.filteredList,
    }
    console.log(this.state.filteredList)
    console.log(this.state.checkedRows)

    const productList = this.state.filteredList.map(item => {
      return (
        <tr key={item.id}>
          <td>{item.product_no}</td>
          <td>{item.name}</td>
          <td>{item.category}</td>
          <td>{item.product_type}</td>
          <td>{JSON.parse(item.qty_data)[0].qty}</td>
          <td>{JSON.parse(item.price_data)[0].price}</td>
          <td>{item.eng_description}</td>
          <td>
            <div className="ps-action-button">
              <Button className="theme-button theme-button-secondary" onClick={() => this.detail(item.id)}>
                View
              </Button>
            </div>
          </td>
        </tr>
      )
    })
    // console.log(this.state.store_type);
    // console.log(this.state.role);
    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />

        <Row>
          <Col md={6}>
            <Row>
              <Label className="text-center" for="sortBy" sm={2}>
                Category
              </Label>

              <Col sm={4}>
                <Input type="select" name="sortKey" value={this.state.sortKey} onChange={this.changeHandler}>
                  <option value="">Default</option>
                  {this.state.categoryList.map(item => {
                    return <option key={item.id}>{item.name}</option>
                  })}
                </Input>
              </Col>
              <Col sm={2}>
                <Button
                  className="theme-button theme-button-dark"
                  onClick={() => {
                    this.filterData()
                  }}>
                  Filter
                </Button>
              </Col>
            </Row>
          </Col>

          {(this.state.store_type == 'Main' || this.state.marketplace == 1) && this.state.role == 'Admin' && (
            <Col md={6}>
              <div className="text-right mb-3">
                <div className="ps-btn-group">
                  <Button className="theme-button theme-button-secondary" onClick={this.toggleImportModal()}>
                    Add All Products
                  </Button>
                  {/* <Button color="link" onClick={this.toggle('ADD', null)}>
                      <IconContext.Provider value={{ color: '#2a2c6b' }}>
                        <BsPlusSquareFill size={25} />
                      </IconContext.Provider>
                    </Button> */}
                  <Button className="theme-button theme-button-primary" onClick={this.toggle('ADD', null)}>
                    Add Product
                  </Button>
                </div>
              </div>
            </Col>
          )}
        </Row>

        <Row>
          <div className="ps-action-button">
            <CSVLink
              data={this.state.filteredList}
              headers={headers}
              filename={this.props.data.store_name + '_Product_List.csv'}
              onClick={() => {
                if (this.state.filteredList.length < 1) {
                  this.CsvNotFound()
                  return false
                }
              }}>
              <Button type="button" className="ps-input-small theme-button-primary">
                Export
              </Button>
            </CSVLink>
            {(this.state.store_type == 'Main' || this.state.marketplace == 1) && this.state.role == 'Admin' && (
              <>
                <Button type="button" className="ps-input-small theme-button-primary" onClick={this.PriceModification}>
                  Price Modification
                </Button>
                <Button type="button" className="ps-input-small theme-button-primary" onClick={this.ProductCondition}>
                  Product Condition
                </Button>
              </>
            )}
          </div>
        </Row>
        <br />
        {(this.state.store_type == 'Main' || this.state.marketplace == 1) && this.state.role == 'Admin' && (
          <Row>
            <div className="ps-action-button">
              <Button type="button" className="ps-input-small theme-button-secondary" onClick={this.toggleIgnoreStockModal()} disabled={this.state.checkedRows.length > 0 ? false : true}>
                Set Ignore Stock
              </Button>
              <Button type="button" className="ps-input-small theme-button-secondary" onClick={this.toggleNettPriceModal()} disabled={this.state.checkedRows.length > 0 ? false : true}>
                Set Nett Price
              </Button>
              <Button type="button" className="ps-input-small theme-button-secondary" onClick={this.toggleConfirmModal()} disabled={this.state.checkedRows.length > 0 ? false : true}>
                Delete
              </Button>
            </div>
          </Row>
        )}
        {this.state.productList.length > 0 ? (
          <MDBDataTable className="ps-storeproduct-table ps-mdb-table" data={data} displayEntries={false} searchTop searchBottom={false} entries={50} fullPagination disableRetreatAfterSorting={true} responsive />
        ) : (
          <Table responsive hover className="ps-table tb-col-13">
            <thead>
              <tr>
                <th></th>
                <th>Product No.</th>
                <th>Name</th>
                <th>Category</th>
                <th>Type</th>
                <th>Price</th>
                <th>Quantity</th>
                <th>Show in Menu</th>
                <th>Ignore Stock</th>
                <th>FB Link</th>
                <th>Badge</th>
                <th>Nett Price</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {this.state.isLoading ? (
                <tr>
                  <td colSpan="11">
                    <div
                      style={{
                        minHeight: '100px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}>
                      <Spinner animation="border" variant="primary" />
                    </div>
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan="11">
                    <div className="ps-empty-data">
                      <div className="empty-content">
                        <MdCreate />
                        <h4>No data to show</h4>
                        <span>Click the 'Create' button to add new product</span>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}

        {/* <Table responsive hover className="ps-table tb-col-8 th-no-wrap">
          <thead>
            <tr>
              <th>Product No.</th>
              <th>Name</th>
              <th>Category</th>
              <th>Type</th>
              <th>Quantity</th>
              <th>Price</th>
              <th>Description</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            
            {productList.length < 1 ? (
              <tr>
                <td colSpan="8">
                  <div className="ps-empty-data">
                    <div className="empty-content">
                      <MdCreate />
                      <h4>No data to show</h4>
                      <span>
                        Click the {this.state.isGlobal ? 'Create' : 'Add'}{' '}
                        button to add new product
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            ) : (
              productList
            )}
          </tbody>
        </Table> */}

        <Modal isOpen={this.state.modal} toggle={this.toggle()} className={this.props.className} centered>
          <PosProductModal history={this.props.history} onToggleModal={this.toggle} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleConfirmModal()}>{this.state.isGlobal ? 'Delete' : 'Remove'} Product</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to delete selected item?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.delete()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.importModal} toggle={this.toggleImportModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleImportModal()}>Import All Product</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to import all product to this store ?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleImportModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.import()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.stockModal} toggle={this.stockModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.stockModal()}>Product Details</ModalHeader>
          <Form className="AuthForm">
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label>Quantity</Label>
                    <Input type="text" name="qty" value={this.state.qty_data != null ? this.state.qty_data[0].qty : 0} readOnly />
                  </FormGroup>
                  <FormGroup>
                    <Label for="stockAction">Action</Label>
                    <Input type="select" name="stockAction" value={this.state.stockAction} onChange={this.changeHandler} required>
                      <option></option>
                      {this.state.actionList.map(item => {
                        return (
                          <option key={item.name} value={item.name}>
                            {item.name}
                          </option>
                        )
                      })}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label>Quantity</Label>
                    <Input type="text" name="amount" value={this.state.amount} onChange={this.changeHandler} required />
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox" name="ignore_stock" checked={this.state.ignore_stock} onChange={this.checkHandler} />
                      Ignore Stock
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              {/* <Button
                className="theme-button theme-button-secondary"
                onClick={this.stockModal()}
              >
                No
              </Button> */}
              <Button className="theme-button theme-button-primary" onClick={() => this.adjustStock()}>
                Submit
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={this.state.ignorestockModal} toggle={this.toggleIgnoreStockModal()} className={this.props.className} centered>
          <PosIgnoreStockForm history={this.props.history} onToggleModal={this.toggleIgnoreStockModal} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        <Modal isOpen={this.state.nettpriceModal} toggle={this.toggleNettPriceModal()} className={this.props.className} centered>
          <PosNettPriceForm history={this.props.history} onToggleModal={this.toggleNettPriceModal} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>
      </>
    )
  }
}
export default PosStoreProductTable
